// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminCategoriesPage {
  background: var(--white-principale);
  min-height: 100vh;
  padding: 12px 0 26px;
  font-family: Arial, sans-serif;
}

.adminCategoriesGrid {
  display: flex;
  justify-content: center;
}

.adminCategoriesCard {
  border-radius: 12px;
  background: var(--white-principale);
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.14);
  padding: 16px;
}

.adminCategoriesCardCenter {
  width: 100%;
  max-width: 1100px;
  margin-top: 16px;
  overflow: hidden;
  /* anti débordements (mobile) */
}

/* =========================
   HEADER
========================= */
.adminCategoriesHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.adminCategoriesTitle {
  font-weight: 900;
  font-size: 14px;
  color: var(--couleur-dark);
}

.adminCategoriesSubtitle {
  margin-top: 4px;
  font-size: 12px;
  color: var(--gris-terciaire);
}

.adminCategoriesHeaderRight {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

/* =========================
   BUTTONS
========================= */
.adminCategoriesBtn {
  border: none;
  border-radius: 999px;
  padding: 8px 12px;
  font-weight: 800;
  font-size: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: filter 0.15s ease, opacity 0.15s ease;
  text-decoration: none;
  background: transparent;
}

.adminCategoriesBtnSoft {
  background: rgba(0, 0, 0, 0.06);
  color: var(--couleur-dark);
}

.adminCategoriesBtnPrimary {
  background: rgba(43, 80, 255, 0.12);
  color: var(--couleur-principale);
}

.adminCategoriesBtnSoft:hover,
.adminCategoriesBtnPrimary:hover {
  filter: brightness(0.96);
}

.adminCategoriesBtn:disabled {
  opacity: 0.6;
  cursor: default;
}

/* =========================
   FILTERS (LIST PAGE)
========================= */
.adminCategoriesFilters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin: 12px 0 14px;
}

.adminCategoriesSearch {
  flex: 1 1 360px;
  min-width: 260px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 999px;
  padding: 8px 12px;
  background: var(--white-principale);
}

.adminCategoriesSearch i {
  color: var(--gris-terciaire);
}

.adminCategoriesSearch input {
  border: none;
  outline: none;
  width: 100%;
  font-size: 12px;
  color: var(--couleur-dark);
  background: transparent;
}

.adminCategoriesSelects {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.adminCategoriesSelects select {
  height: 34px;
  border-radius: 10px;
  border: 1px solid var(--gris-secondaire-2);
  padding: 0 10px;
  font-size: 12px;
  color: var(--couleur-dark);
  background: var(--white-principale);
  outline: none;
}

/* =========================
   TABLE (LIST PAGE)
========================= */
.adminCategoriesTableWrap {
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 12px;
}

.adminCategoriesTable {
  width: 100%;
  border-collapse: collapse;
  min-width: 980px;
}

.adminCategoriesTable thead th {
  text-align: left;
  font-size: 11px;
  color: var(--gris-terciaire);
  font-weight: 900;
  padding: 12px 12px;
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid var(--gris-secondaire-2);
}

.adminCategoriesTable tbody td {
  padding: 12px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  font-size: 12px;
  color: var(--couleur-dark);
  vertical-align: middle;
}

.adminCategoriesTable tbody tr:hover {
  background: rgba(0, 0, 0, 0.02);
}

.muted {
  color: var(--gris-terciaire);
}

.textCenter {
  text-align: center;
}

/* =========================
   CELL ITEM (Catégorie)
========================= */
.adminCategoriesCellItem {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 260px;
}

.adminCategoriesThumb {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.06);
  overflow: hidden;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--couleur-dark);
}

.adminCategoriesCellItemText {
  min-width: 0;
}

.adminCategoriesName {
  font-weight: 900;
  font-size: 17px;
  color: var(--couleur-dark);
  line-height: 1.1;
}

/* =========================
   FIELDS LIST (Desktop)
========================= */
.adminCategoriesFieldsList {
  margin: 0;
  padding-left: 16px;
}

.adminCategoriesFieldsList li {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 3px 0;
  color: var(--couleur-dark);
}

.adminCategoriesFieldsList li i {
  color: var(--gris-terciaire);
}

/* =========================
   BADGES (LIST PAGE)
========================= */
.adminCategoriesBadge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.02em;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.badgeActive {
  background: rgba(28, 180, 93, 0.12);
  color: #1cb45d;
  border-color: rgba(28, 180, 93, 0.18);
}

.badgeArchived {
  background: rgba(108, 117, 125, 0.14);
  color: #6c757d;
  border-color: rgba(108, 117, 125, 0.22);
}

/* =========================
   ACTIONS (LIST PAGE)
========================= */
.colActions {
  width: 140px;
}

.adminCategoriesActions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.adminCategoriesIconBtn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: filter 0.15s ease, transform 0.06s ease;
  text-decoration: none;
  color: inherit;
}

.adminCategoriesIconBtn:hover {
  filter: brightness(0.98);
}

.adminCategoriesIconBtn:active {
  transform: scale(0.98);
}

.adminCategoriesIconBtn.danger {
  border-color: rgba(220, 53, 69, 0.25);
  color: #dc3545;
}

/* =========================
   EMPTY / LOADER
========================= */
.adminCategoriesEmpty {
  padding: 22px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: var(--gris-terciaire);
  text-align: center;
}

.adminCategoriesEmpty i {
  font-size: 22px;
}

.adminCategoriesSpinner {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: 2px solid rgba(0, 0, 0, 0.18);
  border-top-color: rgba(0, 0, 0, 0.45);
  animation: adminCategoriesSpin 0.8s linear infinite;
}

@keyframes adminCategoriesSpin {
  to {
    transform: rotate(360deg);
  }
}

/* =========================
   PAGINATION (LIST PAGE)
========================= */
.adminCategoriesPagination {
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.adminCategoriesPageBtn {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: var(--white-principale);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: filter 0.15s ease, transform 0.06s ease;
}

.adminCategoriesPageBtn:hover {
  filter: brightness(0.98);
}

.adminCategoriesPageBtn:active {
  transform: scale(0.98);
}

.adminCategoriesPageBtn:disabled {
  opacity: 0.55;
  cursor: default;
}

.adminCategoriesPageInfo {
  font-size: 12px;
  color: var(--gris-terciaire);
}

/* =========================
   RESPONSIVE HELPERS (LIST)
========================= */
.hideOnMobile {
  display: table-cell;
}

.adminCategoriesMobileMeta {
  display: none;
}

/* Chips (mobile fields preview) */
.adminCategoriesMobileFields {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.adminCategoriesChip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: rgba(0, 0, 0, 0.04);
  color: var(--couleur-dark);
}

/* =======================================================
   CREATE / EDIT FORM — mêmes tokens/typographies que LIST
======================================================= */
.adminCategoriesForm {
  margin-top: 10px;
}

.adminCategoriesFormGrid {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 12px;
}

.adminCategoriesFormGroup {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.adminCategoriesLabel {
  font-size: 11px;
  font-weight: 900;
  color: var(--gris-terciaire);
}

.adminCategoriesInput,
.adminCategoriesSelect {
  height: 38px;
  border-radius: 12px;
  border: 1px solid var(--gris-secondaire-2);
  padding: 0 12px;
  font-size: 12px;
  color: var(--couleur-dark);
  background: var(--white-principale);
  outline: none;
}

.adminCategoriesInput:disabled,
.adminCategoriesSelect:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.adminCategoriesDivider {
  height: 1px;
  background: rgba(0, 0, 0, 0.08);
  margin: 14px 0;
}

.adminCategoriesSectionHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.adminCategoriesSectionTitle {
  font-weight: 900;
  font-size: 13px;
  color: var(--couleur-dark);
}

.adminCategoriesHint {
  font-size: 12px;
  color: var(--gris-terciaire);
  background: rgba(0, 0, 0, 0.03);
  border: 1px dashed rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  padding: 12px;
}

.adminCategoriesFieldsWrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.adminCategoriesFieldRow {
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 14px;
  padding: 12px;
  background: var(--white-principale);
  display: flex;
  gap: 12px;
  align-items: flex-start;
  justify-content: space-between;
}

.adminCategoriesFieldLeft {
  flex: 1 1;
  min-width: 0;
}

.adminCategoriesFieldRight {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  padding-top: 22px;
}

.adminCategoriesIconPickerWrap {
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 12px;
  padding: 10px;
  background: rgba(0, 0, 0, 0.02);
}

.mt8 {
  margin-top: 8px;
}

.adminCategoriesFormActions {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}


/* ==========================================================================
   MODAL — Modification groupée des catégories
   ========================================================================== */

@keyframes bulkModalFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes bulkModalSlideUp {
  from {
    opacity: 0;
    transform: translateY(24px) scale(0.97);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes bulkModalSpin {
  to {
    transform: rotate(360deg);
  }
}

.bulkModalBackdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(2px);
  z-index: 1040;
  animation: bulkModalFadeIn 0.18s ease-out;
}

.bulkModalOverlay {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
}

.bulkModalDialog {
  width: 100%;
  max-width: 600px;
  animation: bulkModalSlideUp 0.22s cubic-bezier(0.16, 1, 0.3, 1);
}

.bulkModalContent {
  background-color: var(--white-principale);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.28), 0 4px 16px var(--gris-shadow);
  font-family: "Lato", sans-serif;
}

/* ---------------------------- Header ---------------------------- */

.bulkModalHeader {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 22px 26px;
  background: linear-gradient(135deg, var(--couleur-principale) 0%, #3a2ff0 100%);
  position: relative;
  overflow: hidden;
}

.bulkModalHeader::after {
  content: "";
  position: absolute;
  top: -60%;
  right: -10%;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  pointer-events: none;
}

.bulkModalHeaderIcon {
  width: 42px;
  height: 42px;
  min-width: 42px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white-principale);
  font-size: 18px;
  z-index: 1;
}

.bulkModalHeaderText {
  display: flex;
  flex-direction: column;
  gap: 2px;
  z-index: 1;
  min-width: 0;
}

.bulkModalTitle {
  color: var(--white-principale);
  font-size: var(--font-size-detail-section);
  font-weight: var(--font-weight-title);
  margin: 0;
  line-height: 1.2;
}

.bulkModalSubtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: var(--font-size-location);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ---------------------------- Body ---------------------------- */

.bulkModalBody {
  padding: 22px 26px;
  max-height: 62vh;
  overflow-y: auto;
}

.bulkModalInfo {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background-color: #f4f3ff;
  border: 1px solid #e0dcff;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 20px;
}

.bulkModalInfo i {
  color: var(--couleur-principale);
  font-size: 16px;
  margin-top: 2px;
  flex-shrink: 0;
}

.bulkModalInfo p {
  margin: 0;
  font-size: var(--font-size-detail-text);
  color: var(--couleur-dark-primary);
  line-height: 1.5;
}

.bulkModalInfo p b {
  color: var(--couleur-principale);
  font-weight: var(--font-weight-title);
}

/* ---------------------------- Grille des champs ---------------------------- */

.bulkModalFieldsGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.bulkModalField {
  border: 1.5px solid var(--gris-secondaire-3);
  border-radius: 12px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: var(--white-principale);
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.bulkModalField:hover {
  border-color: var(--gris-terciaire-2);
}

.bulkModalField.isActive {
  border-color: var(--couleur-principale);
  background-color: #f8f7ff;
  box-shadow: 0 0 0 3px rgba(11, 0, 207, 0.08);
}

/* Checkbox custom */

.bulkModalCheck {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.bulkModalCheck input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.bulkModalCheckmark {
  width: 20px;
  height: 20px;
  min-width: 20px;
  border-radius: 6px;
  border: 2px solid var(--gris-principale);
  position: relative;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  flex-shrink: 0;
}

.bulkModalCheckmark::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid var(--white-principale);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  opacity: 0;
  transition: opacity 0.1s ease;
}

.bulkModalCheck input:checked~.bulkModalCheckmark {
  background-color: var(--couleur-principale);
  border-color: var(--couleur-principale);
}

.bulkModalCheck input:checked~.bulkModalCheckmark::after {
  opacity: 1;
}

.bulkModalCheck input:focus-visible~.bulkModalCheckmark {
  box-shadow: 0 0 0 3px rgba(11, 0, 207, 0.2);
}

.bulkModalFieldLabel {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-btn);
  font-weight: var(--font-weight-medium);
  color: var(--couleur-dark);
}

.bulkModalFieldLabel i {
  color: var(--couleur-principale);
  font-size: 15px;
}

/* Inputs / Selects */

.bulkModalInputWrap {
  position: relative;
  display: flex;
  align-items: center;
}

.bulkModalInput,
.bulkModalSelect {
  width: 100%;
  font-family: "Lato", sans-serif;
  font-size: var(--font-size-btn);
  color: var(--couleur-dark);
  background-color: var(--gris-foncer);
  border: 1px solid var(--gris-secondaire-3);
  border-radius: 8px;
  padding: 9px 12px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.bulkModalInput {
  padding-right: 36px;
}

.bulkModalInputSuffix {
  position: absolute;
  right: 12px;
  font-size: var(--font-size-location);
  font-weight: var(--font-weight-medium);
  color: var(--gris-tertiaire-2);
  pointer-events: none;
}

.bulkModalField.isActive .bulkModalInput,
.bulkModalField.isActive .bulkModalSelect {
  background-color: var(--white-principale);
}

.bulkModalInput:disabled,
.bulkModalSelect:disabled {
  background-color: var(--white-tertiaire);
  color: var(--gris-tertiaire-2);
  cursor: not-allowed;
  opacity: 0.75;
}

.bulkModalInput:not(:disabled):focus,
.bulkModalSelect:not(:disabled):focus {
  outline: none;
  border-color: var(--couleur-principale);
  box-shadow: 0 0 0 3px rgba(11, 0, 207, 0.14);
}

.bulkModalSelect:not(:disabled) {
  cursor: pointer;
}

/* Scrollbar */

.bulkModalBody::-webkit-scrollbar {
  width: 8px;
}

.bulkModalBody::-webkit-scrollbar-track {
  background: transparent;
}

.bulkModalBody::-webkit-scrollbar-thumb {
  background-color: var(--gris-secondaire-3);
  border-radius: 8px;
}

.bulkModalBody::-webkit-scrollbar-thumb:hover {
  background-color: var(--gris-principale);
}

/* ---------------------------- Footer ---------------------------- */

.bulkModalFooter {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 26px;
  border-top: 1px solid var(--gris-secondaire-3);
  background-color: var(--gris-foncer);
}

.bulkModalBtn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: "Lato", sans-serif;
  font-size: var(--font-size-btn);
  font-weight: var(--font-weight-medium);
  border-radius: 9px;
  padding: 10px 20px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.12s ease, opacity 0.12s ease, background-color 0.12s ease;
}

.bulkModalBtnSoft {
  background-color: var(--white-principale);
  color: var(--couleur-dark);
  border-color: var(--gris-secondaire-3);
}

.bulkModalBtnSoft:hover:not(:disabled) {
  background-color: var(--gris-secondaire-2);
}

.bulkModalBtnPrimary {
  background-color: var(--couleur-principale);
  color: var(--white-principale);
}

.bulkModalBtnPrimary:hover:not(:disabled) {
  background-color: #0a00b8;
  box-shadow: 0 6px 16px rgba(11, 0, 207, 0.32);
  transform: translateY(-1px);
}

.bulkModalBtn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.bulkModalSpinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: var(--white-principale);
  border-radius: 50%;
  animation: bulkModalSpin 0.7s linear infinite;
}

/* ---------------------------- Responsive ---------------------------- */

@media (max-width: 640px) {
  .bulkModalOverlay {
    padding: 0;
    align-items: flex-end;
  }

  .bulkModalDialog {
    max-width: 100%;
    animation: bulkModalSlideUp 0.22s cubic-bezier(0.16, 1, 0.3, 1);
  }

  .bulkModalContent {
    border-radius: 18px 18px 0 0;
    max-height: 92vh;
    display: flex;
    flex-direction: column;
  }

  .bulkModalForm {
    display: flex;
    flex-direction: column;
    max-height: 92vh;
  }

  .bulkModalHeader {
    padding: 18px 20px;
  }

  .bulkModalBody {
    padding: 18px 20px;
    flex: 1 1;
  }

  .bulkModalFieldsGrid {
    grid-template-columns: 1fr;
  }

  .bulkModalFooter {
    padding: 14px 20px;
    padding-bottom: max(14px, env(safe-area-inset-bottom));
    flex-direction: column-reverse;
  }

  .bulkModalBtn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 400px) {
  .bulkModalSubtitle {
    max-width: 200px;
  }
}

/* =========================================
   MOBILE MODE — SANS SCROLL HORIZONTAL
========================================= */
@media (max-width: 720px) {

  /* Header en colonne */
  .adminCategoriesHeader {
    flex-direction: column;
    align-items: stretch;
  }

  .adminCategoriesHeaderRight {
    justify-content: flex-end;
  }

  /* Filters : en colonne */
  .adminCategoriesFilters {
    flex-direction: column;
    align-items: stretch;
  }

  .adminCategoriesSearch {
    width: 100%;
    min-width: 0;
    flex: 1 1 auto;
  }

  .adminCategoriesSelects {
    width: 100%;
  }

  .adminCategoriesSelects select {
    width: 100%;
  }

  /* FORM en colonne */
  .adminCategoriesFormGrid {
    grid-template-columns: 1fr;
  }

  .adminCategoriesFieldRow {
    flex-direction: column;
  }

  .adminCategoriesFieldRight {
    padding-top: 0;
    justify-content: flex-end;
  }

  /* LIST: Masquer colonnes desktop */
  .hideOnMobile {
    display: none !important;
  }

  /* LIST: Désactiver table large */
  .adminCategoriesTable {
    min-width: 0;
  }

  /* LIST: Masquer entête */
  .adminCategoriesTable thead {
    display: none;
  }

  /* LIST: Wrap sans scroll */
  .adminCategoriesTableWrap {
    border: none;
    overflow: visible;
  }

  /* LIST: tbody en colonne */
  .adminCategoriesTable tbody {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  /* LIST: tr en card */
  .adminCategoriesTable tbody tr {
    display: block;
    border: 1px solid var(--gris-secondaire-2);
    border-radius: 14px;
    padding: 10px;
    background: var(--white-principale);
  }

  /* LIST: td en bloc */
  .adminCategoriesTable tbody td {
    display: block;
    border-bottom: none;
    padding: 6px 4px;
  }

  /* anti overflow */
  .adminCategoriesCellItem {
    min-width: 0;
  }

  .adminCategoriesCellItemText {
    min-width: 0;
  }

  .adminCategoriesName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  /* LIST: Mobile meta visible */
  .adminCategoriesMobileMeta {
    display: block;
    margin-top: 8px;
    font-size: 11px;
    color: var(--gris-terciaire);
    line-height: 1.35;
  }

  .adminCategoriesMobileMeta div {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;
  }

  /* LIST: actions */
  .colActions {
    width: auto;
  }

  .adminCategoriesActions {
    justify-content: flex-end;
    margin-top: 6px;
  }

  .textCenter {
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/admin/gestionCategorie/AdminCategoriesPage.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;2BAE2B;AAC3B;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iDAAiD;EACjD,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0CAA0C;EAC1C,oBAAoB;EACpB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,aAAa;AACf;;AAEA;;2BAE2B;AAC3B;EACE,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;2BAE2B;AAC3B;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;2BAE2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,uCAAuC;AACzC;;AAEA;;2BAE2B;AAC3B;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mDAAmD;EACnD,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;2BAE2B;AAC3B;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,qCAAqC;EACrC,mDAAmD;AACrD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;2BAE2B;AAC3B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;2BAE2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;yDAEyD;AACzD;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,+BAA+B;EAC/B,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;;AAGA;;+EAE+E;;AAE/E;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,0BAA0B;EAC1B,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+DAA+D;AACjE;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,0EAA0E;EAC1E,+BAA+B;AACjC;;AAEA,qEAAqE;;AAErE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+EAA+E;EAC/E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mEAAmE;;AAEnE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;EACzC,uFAAuF;AACzF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,gEAAgE;EAChE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;EACzB,wBAAwB;EACxB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA,qBAAqB;;AAErB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,uFAAuF;AACzF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,wCAAwC;EACxC,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA,cAAc;;AAEd;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,qEAAqE;;AAErE;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,+BAA+B;EAC/B,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,wGAAwG;AAC1G;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yCAAyC;EACzC,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA,yEAAyE;;AAEzE;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,+DAA+D;EACjE;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAO;EACT;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,sDAAsD;IACtD,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;2CAE2C;AAC3C;;EAEE,sBAAsB;EACtB;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,yBAAyB;EACzB;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA,oBAAoB;EACpB;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,yBAAyB;EAC3B;;EAEA,mCAAmC;EACnC;IACE,wBAAwB;EAC1B;;EAEA,iCAAiC;EACjC;IACE,YAAY;EACd;;EAEA,yBAAyB;EACzB;IACE,aAAa;EACf;;EAEA,2BAA2B;EAC3B;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA,2BAA2B;EAC3B;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,qBAAqB;EACrB;IACE,cAAc;IACd,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,mCAAmC;EACrC;;EAEA,qBAAqB;EACrB;IACE,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;EACjB;;EAEA,8BAA8B;EAC9B;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;EACjB;;EAEA,kBAAkB;EAClB;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".adminCategoriesPage {\n  background: var(--white-principale);\n  min-height: 100vh;\n  padding: 12px 0 26px;\n  font-family: Arial, sans-serif;\n}\n\n.adminCategoriesGrid {\n  display: flex;\n  justify-content: center;\n}\n\n.adminCategoriesCard {\n  border-radius: 12px;\n  background: var(--white-principale);\n  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.14);\n  padding: 16px;\n}\n\n.adminCategoriesCardCenter {\n  width: 100%;\n  max-width: 1100px;\n  margin-top: 16px;\n  overflow: hidden;\n  /* anti débordements (mobile) */\n}\n\n/* =========================\n   HEADER\n========================= */\n.adminCategoriesHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.adminCategoriesTitle {\n  font-weight: 900;\n  font-size: 14px;\n  color: var(--couleur-dark);\n}\n\n.adminCategoriesSubtitle {\n  margin-top: 4px;\n  font-size: 12px;\n  color: var(--gris-terciaire);\n}\n\n.adminCategoriesHeaderRight {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n/* =========================\n   BUTTONS\n========================= */\n.adminCategoriesBtn {\n  border: none;\n  border-radius: 999px;\n  padding: 8px 12px;\n  font-weight: 800;\n  font-size: 12px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: filter 0.15s ease, opacity 0.15s ease;\n  text-decoration: none;\n  background: transparent;\n}\n\n.adminCategoriesBtnSoft {\n  background: rgba(0, 0, 0, 0.06);\n  color: var(--couleur-dark);\n}\n\n.adminCategoriesBtnPrimary {\n  background: rgba(43, 80, 255, 0.12);\n  color: var(--couleur-principale);\n}\n\n.adminCategoriesBtnSoft:hover,\n.adminCategoriesBtnPrimary:hover {\n  filter: brightness(0.96);\n}\n\n.adminCategoriesBtn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n/* =========================\n   FILTERS (LIST PAGE)\n========================= */\n.adminCategoriesFilters {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin: 12px 0 14px;\n}\n\n.adminCategoriesSearch {\n  flex: 1 1 360px;\n  min-width: 260px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 999px;\n  padding: 8px 12px;\n  background: var(--white-principale);\n}\n\n.adminCategoriesSearch i {\n  color: var(--gris-terciaire);\n}\n\n.adminCategoriesSearch input {\n  border: none;\n  outline: none;\n  width: 100%;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: transparent;\n}\n\n.adminCategoriesSelects {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.adminCategoriesSelects select {\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid var(--gris-secondaire-2);\n  padding: 0 10px;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: var(--white-principale);\n  outline: none;\n}\n\n/* =========================\n   TABLE (LIST PAGE)\n========================= */\n.adminCategoriesTableWrap {\n  width: 100%;\n  overflow-x: auto;\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 12px;\n}\n\n.adminCategoriesTable {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 980px;\n}\n\n.adminCategoriesTable thead th {\n  text-align: left;\n  font-size: 11px;\n  color: var(--gris-terciaire);\n  font-weight: 900;\n  padding: 12px 12px;\n  background: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid var(--gris-secondaire-2);\n}\n\n.adminCategoriesTable tbody td {\n  padding: 12px 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  font-size: 12px;\n  color: var(--couleur-dark);\n  vertical-align: middle;\n}\n\n.adminCategoriesTable tbody tr:hover {\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.muted {\n  color: var(--gris-terciaire);\n}\n\n.textCenter {\n  text-align: center;\n}\n\n/* =========================\n   CELL ITEM (Catégorie)\n========================= */\n.adminCategoriesCellItem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 260px;\n}\n\n.adminCategoriesThumb {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--couleur-dark);\n}\n\n.adminCategoriesCellItemText {\n  min-width: 0;\n}\n\n.adminCategoriesName {\n  font-weight: 900;\n  font-size: 17px;\n  color: var(--couleur-dark);\n  line-height: 1.1;\n}\n\n/* =========================\n   FIELDS LIST (Desktop)\n========================= */\n.adminCategoriesFieldsList {\n  margin: 0;\n  padding-left: 16px;\n}\n\n.adminCategoriesFieldsList li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 3px 0;\n  color: var(--couleur-dark);\n}\n\n.adminCategoriesFieldsList li i {\n  color: var(--gris-terciaire);\n}\n\n/* =========================\n   BADGES (LIST PAGE)\n========================= */\n.adminCategoriesBadge {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 900;\n  letter-spacing: 0.02em;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.badgeActive {\n  background: rgba(28, 180, 93, 0.12);\n  color: #1cb45d;\n  border-color: rgba(28, 180, 93, 0.18);\n}\n\n.badgeArchived {\n  background: rgba(108, 117, 125, 0.14);\n  color: #6c757d;\n  border-color: rgba(108, 117, 125, 0.22);\n}\n\n/* =========================\n   ACTIONS (LIST PAGE)\n========================= */\n.colActions {\n  width: 140px;\n}\n\n.adminCategoriesActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.adminCategoriesIconBtn {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: filter 0.15s ease, transform 0.06s ease;\n  text-decoration: none;\n  color: inherit;\n}\n\n.adminCategoriesIconBtn:hover {\n  filter: brightness(0.98);\n}\n\n.adminCategoriesIconBtn:active {\n  transform: scale(0.98);\n}\n\n.adminCategoriesIconBtn.danger {\n  border-color: rgba(220, 53, 69, 0.25);\n  color: #dc3545;\n}\n\n/* =========================\n   EMPTY / LOADER\n========================= */\n.adminCategoriesEmpty {\n  padding: 22px 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: var(--gris-terciaire);\n  text-align: center;\n}\n\n.adminCategoriesEmpty i {\n  font-size: 22px;\n}\n\n.adminCategoriesSpinner {\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  border: 2px solid rgba(0, 0, 0, 0.18);\n  border-top-color: rgba(0, 0, 0, 0.45);\n  animation: adminCategoriesSpin 0.8s linear infinite;\n}\n\n@keyframes adminCategoriesSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* =========================\n   PAGINATION (LIST PAGE)\n========================= */\n.adminCategoriesPagination {\n  margin-top: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.adminCategoriesPageBtn {\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: var(--white-principale);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: filter 0.15s ease, transform 0.06s ease;\n}\n\n.adminCategoriesPageBtn:hover {\n  filter: brightness(0.98);\n}\n\n.adminCategoriesPageBtn:active {\n  transform: scale(0.98);\n}\n\n.adminCategoriesPageBtn:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n.adminCategoriesPageInfo {\n  font-size: 12px;\n  color: var(--gris-terciaire);\n}\n\n/* =========================\n   RESPONSIVE HELPERS (LIST)\n========================= */\n.hideOnMobile {\n  display: table-cell;\n}\n\n.adminCategoriesMobileMeta {\n  display: none;\n}\n\n/* Chips (mobile fields preview) */\n.adminCategoriesMobileFields {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.adminCategoriesChip {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 800;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--couleur-dark);\n}\n\n/* =======================================================\n   CREATE / EDIT FORM — mêmes tokens/typographies que LIST\n======================================================= */\n.adminCategoriesForm {\n  margin-top: 10px;\n}\n\n.adminCategoriesFormGrid {\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  gap: 12px;\n}\n\n.adminCategoriesFormGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.adminCategoriesLabel {\n  font-size: 11px;\n  font-weight: 900;\n  color: var(--gris-terciaire);\n}\n\n.adminCategoriesInput,\n.adminCategoriesSelect {\n  height: 38px;\n  border-radius: 12px;\n  border: 1px solid var(--gris-secondaire-2);\n  padding: 0 12px;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: var(--white-principale);\n  outline: none;\n}\n\n.adminCategoriesInput:disabled,\n.adminCategoriesSelect:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.adminCategoriesDivider {\n  height: 1px;\n  background: rgba(0, 0, 0, 0.08);\n  margin: 14px 0;\n}\n\n.adminCategoriesSectionHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.adminCategoriesSectionTitle {\n  font-weight: 900;\n  font-size: 13px;\n  color: var(--couleur-dark);\n}\n\n.adminCategoriesHint {\n  font-size: 12px;\n  color: var(--gris-terciaire);\n  background: rgba(0, 0, 0, 0.03);\n  border: 1px dashed rgba(0, 0, 0, 0.12);\n  border-radius: 12px;\n  padding: 12px;\n}\n\n.adminCategoriesFieldsWrap {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.adminCategoriesFieldRow {\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 14px;\n  padding: 12px;\n  background: var(--white-principale);\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.adminCategoriesFieldLeft {\n  flex: 1;\n  min-width: 0;\n}\n\n.adminCategoriesFieldRight {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: flex-start;\n  padding-top: 22px;\n}\n\n.adminCategoriesIconPickerWrap {\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 12px;\n  padding: 10px;\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.mt8 {\n  margin-top: 8px;\n}\n\n.adminCategoriesFormActions {\n  margin-top: 14px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n\n/* ==========================================================================\n   MODAL — Modification groupée des catégories\n   ========================================================================== */\n\n@keyframes bulkModalFadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes bulkModalSlideUp {\n  from {\n    opacity: 0;\n    transform: translateY(24px) scale(0.97);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes bulkModalSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.bulkModalBackdrop {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(2px);\n  z-index: 1040;\n  animation: bulkModalFadeIn 0.18s ease-out;\n}\n\n.bulkModalOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.bulkModalDialog {\n  width: 100%;\n  max-width: 600px;\n  animation: bulkModalSlideUp 0.22s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.bulkModalContent {\n  background-color: var(--white-principale);\n  border-radius: 18px;\n  overflow: hidden;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.28), 0 4px 16px var(--gris-shadow);\n  font-family: \"Lato\", sans-serif;\n}\n\n/* ---------------------------- Header ---------------------------- */\n\n.bulkModalHeader {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 22px 26px;\n  background: linear-gradient(135deg, var(--couleur-principale) 0%, #3a2ff0 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n.bulkModalHeader::after {\n  content: \"\";\n  position: absolute;\n  top: -60%;\n  right: -10%;\n  width: 220px;\n  height: 220px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.08);\n  pointer-events: none;\n}\n\n.bulkModalHeaderIcon {\n  width: 42px;\n  height: 42px;\n  min-width: 42px;\n  border-radius: 12px;\n  background-color: rgba(255, 255, 255, 0.16);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white-principale);\n  font-size: 18px;\n  z-index: 1;\n}\n\n.bulkModalHeaderText {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  z-index: 1;\n  min-width: 0;\n}\n\n.bulkModalTitle {\n  color: var(--white-principale);\n  font-size: var(--font-size-detail-section);\n  font-weight: var(--font-weight-title);\n  margin: 0;\n  line-height: 1.2;\n}\n\n.bulkModalSubtitle {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: var(--font-size-location);\n  font-weight: var(--font-weight-medium);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ---------------------------- Body ---------------------------- */\n\n.bulkModalBody {\n  padding: 22px 26px;\n  max-height: 62vh;\n  overflow-y: auto;\n}\n\n.bulkModalInfo {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  background-color: #f4f3ff;\n  border: 1px solid #e0dcff;\n  border-radius: 10px;\n  padding: 12px 14px;\n  margin-bottom: 20px;\n}\n\n.bulkModalInfo i {\n  color: var(--couleur-principale);\n  font-size: 16px;\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n.bulkModalInfo p {\n  margin: 0;\n  font-size: var(--font-size-detail-text);\n  color: var(--couleur-dark-primary);\n  line-height: 1.5;\n}\n\n.bulkModalInfo p b {\n  color: var(--couleur-principale);\n  font-weight: var(--font-weight-title);\n}\n\n/* ---------------------------- Grille des champs ---------------------------- */\n\n.bulkModalFieldsGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.bulkModalField {\n  border: 1.5px solid var(--gris-secondaire-3);\n  border-radius: 12px;\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  background-color: var(--white-principale);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;\n}\n\n.bulkModalField:hover {\n  border-color: var(--gris-terciaire-2);\n}\n\n.bulkModalField.isActive {\n  border-color: var(--couleur-principale);\n  background-color: #f8f7ff;\n  box-shadow: 0 0 0 3px rgba(11, 0, 207, 0.08);\n}\n\n/* Checkbox custom */\n\n.bulkModalCheck {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.bulkModalCheck input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.bulkModalCheckmark {\n  width: 20px;\n  height: 20px;\n  min-width: 20px;\n  border-radius: 6px;\n  border: 2px solid var(--gris-principale);\n  position: relative;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.bulkModalCheckmark::after {\n  content: \"\";\n  position: absolute;\n  left: 6px;\n  top: 2px;\n  width: 5px;\n  height: 10px;\n  border: solid var(--white-principale);\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n  opacity: 0;\n  transition: opacity 0.1s ease;\n}\n\n.bulkModalCheck input:checked~.bulkModalCheckmark {\n  background-color: var(--couleur-principale);\n  border-color: var(--couleur-principale);\n}\n\n.bulkModalCheck input:checked~.bulkModalCheckmark::after {\n  opacity: 1;\n}\n\n.bulkModalCheck input:focus-visible~.bulkModalCheckmark {\n  box-shadow: 0 0 0 3px rgba(11, 0, 207, 0.2);\n}\n\n.bulkModalFieldLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--font-size-btn);\n  font-weight: var(--font-weight-medium);\n  color: var(--couleur-dark);\n}\n\n.bulkModalFieldLabel i {\n  color: var(--couleur-principale);\n  font-size: 15px;\n}\n\n/* Inputs / Selects */\n\n.bulkModalInputWrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.bulkModalInput,\n.bulkModalSelect {\n  width: 100%;\n  font-family: \"Lato\", sans-serif;\n  font-size: var(--font-size-btn);\n  color: var(--couleur-dark);\n  background-color: var(--gris-foncer);\n  border: 1px solid var(--gris-secondaire-3);\n  border-radius: 8px;\n  padding: 9px 12px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;\n}\n\n.bulkModalInput {\n  padding-right: 36px;\n}\n\n.bulkModalInputSuffix {\n  position: absolute;\n  right: 12px;\n  font-size: var(--font-size-location);\n  font-weight: var(--font-weight-medium);\n  color: var(--gris-tertiaire-2);\n  pointer-events: none;\n}\n\n.bulkModalField.isActive .bulkModalInput,\n.bulkModalField.isActive .bulkModalSelect {\n  background-color: var(--white-principale);\n}\n\n.bulkModalInput:disabled,\n.bulkModalSelect:disabled {\n  background-color: var(--white-tertiaire);\n  color: var(--gris-tertiaire-2);\n  cursor: not-allowed;\n  opacity: 0.75;\n}\n\n.bulkModalInput:not(:disabled):focus,\n.bulkModalSelect:not(:disabled):focus {\n  outline: none;\n  border-color: var(--couleur-principale);\n  box-shadow: 0 0 0 3px rgba(11, 0, 207, 0.14);\n}\n\n.bulkModalSelect:not(:disabled) {\n  cursor: pointer;\n}\n\n/* Scrollbar */\n\n.bulkModalBody::-webkit-scrollbar {\n  width: 8px;\n}\n\n.bulkModalBody::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.bulkModalBody::-webkit-scrollbar-thumb {\n  background-color: var(--gris-secondaire-3);\n  border-radius: 8px;\n}\n\n.bulkModalBody::-webkit-scrollbar-thumb:hover {\n  background-color: var(--gris-principale);\n}\n\n/* ---------------------------- Footer ---------------------------- */\n\n.bulkModalFooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 26px;\n  border-top: 1px solid var(--gris-secondaire-3);\n  background-color: var(--gris-foncer);\n}\n\n.bulkModalBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-family: \"Lato\", sans-serif;\n  font-size: var(--font-size-btn);\n  font-weight: var(--font-weight-medium);\n  border-radius: 9px;\n  padding: 10px 20px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: transform 0.12s ease, box-shadow 0.12s ease, opacity 0.12s ease, background-color 0.12s ease;\n}\n\n.bulkModalBtnSoft {\n  background-color: var(--white-principale);\n  color: var(--couleur-dark);\n  border-color: var(--gris-secondaire-3);\n}\n\n.bulkModalBtnSoft:hover:not(:disabled) {\n  background-color: var(--gris-secondaire-2);\n}\n\n.bulkModalBtnPrimary {\n  background-color: var(--couleur-principale);\n  color: var(--white-principale);\n}\n\n.bulkModalBtnPrimary:hover:not(:disabled) {\n  background-color: #0a00b8;\n  box-shadow: 0 6px 16px rgba(11, 0, 207, 0.32);\n  transform: translateY(-1px);\n}\n\n.bulkModalBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.bulkModalSpinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: var(--white-principale);\n  border-radius: 50%;\n  animation: bulkModalSpin 0.7s linear infinite;\n}\n\n/* ---------------------------- Responsive ---------------------------- */\n\n@media (max-width: 640px) {\n  .bulkModalOverlay {\n    padding: 0;\n    align-items: flex-end;\n  }\n\n  .bulkModalDialog {\n    max-width: 100%;\n    animation: bulkModalSlideUp 0.22s cubic-bezier(0.16, 1, 0.3, 1);\n  }\n\n  .bulkModalContent {\n    border-radius: 18px 18px 0 0;\n    max-height: 92vh;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .bulkModalForm {\n    display: flex;\n    flex-direction: column;\n    max-height: 92vh;\n  }\n\n  .bulkModalHeader {\n    padding: 18px 20px;\n  }\n\n  .bulkModalBody {\n    padding: 18px 20px;\n    flex: 1;\n  }\n\n  .bulkModalFieldsGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .bulkModalFooter {\n    padding: 14px 20px;\n    padding-bottom: max(14px, env(safe-area-inset-bottom));\n    flex-direction: column-reverse;\n  }\n\n  .bulkModalBtn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 400px) {\n  .bulkModalSubtitle {\n    max-width: 200px;\n  }\n}\n\n/* =========================================\n   MOBILE MODE — SANS SCROLL HORIZONTAL\n========================================= */\n@media (max-width: 720px) {\n\n  /* Header en colonne */\n  .adminCategoriesHeader {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .adminCategoriesHeaderRight {\n    justify-content: flex-end;\n  }\n\n  /* Filters : en colonne */\n  .adminCategoriesFilters {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .adminCategoriesSearch {\n    width: 100%;\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  .adminCategoriesSelects {\n    width: 100%;\n  }\n\n  .adminCategoriesSelects select {\n    width: 100%;\n  }\n\n  /* FORM en colonne */\n  .adminCategoriesFormGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .adminCategoriesFieldRow {\n    flex-direction: column;\n  }\n\n  .adminCategoriesFieldRight {\n    padding-top: 0;\n    justify-content: flex-end;\n  }\n\n  /* LIST: Masquer colonnes desktop */\n  .hideOnMobile {\n    display: none !important;\n  }\n\n  /* LIST: Désactiver table large */\n  .adminCategoriesTable {\n    min-width: 0;\n  }\n\n  /* LIST: Masquer entête */\n  .adminCategoriesTable thead {\n    display: none;\n  }\n\n  /* LIST: Wrap sans scroll */\n  .adminCategoriesTableWrap {\n    border: none;\n    overflow: visible;\n  }\n\n  /* LIST: tbody en colonne */\n  .adminCategoriesTable tbody {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  /* LIST: tr en card */\n  .adminCategoriesTable tbody tr {\n    display: block;\n    border: 1px solid var(--gris-secondaire-2);\n    border-radius: 14px;\n    padding: 10px;\n    background: var(--white-principale);\n  }\n\n  /* LIST: td en bloc */\n  .adminCategoriesTable tbody td {\n    display: block;\n    border-bottom: none;\n    padding: 6px 4px;\n  }\n\n  /* anti overflow */\n  .adminCategoriesCellItem {\n    min-width: 0;\n  }\n\n  .adminCategoriesCellItemText {\n    min-width: 0;\n  }\n\n  .adminCategoriesName {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n  }\n\n  /* LIST: Mobile meta visible */\n  .adminCategoriesMobileMeta {\n    display: block;\n    margin-top: 8px;\n    font-size: 11px;\n    color: var(--gris-terciaire);\n    line-height: 1.35;\n  }\n\n  .adminCategoriesMobileMeta div {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 4px;\n  }\n\n  /* LIST: actions */\n  .colActions {\n    width: auto;\n  }\n\n  .adminCategoriesActions {\n    justify-content: flex-end;\n    margin-top: 6px;\n  }\n\n  .textCenter {\n    text-align: left;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
